import Carousel from "./components/homeScreen/Carousel";
import WhoAreWeSection from "./components/homeScreen/WhoAreWeSection";
import Banner from "./components/homeScreen/Banner";
import ServicesSection from "./components/homeScreen/ServicesSection";
import TestimonialsSection from "./components/homeScreen/TestimonialsSection";
import FormSection from "./components/homeScreen/FormSection";

function App() {
	return (
		<div>
			<Carousel />
			<WhoAreWeSection />
			<Banner />
			<ServicesSection />
			<TestimonialsSection />
			<FormSection />
		</div>
	);
}

export default App;
